import { reportError } from "./errors.utils";
import { NoOp } from "./functions.utils";
export default function addListener(element, events, handler) {
    var eventList = events instanceof Array ? events : (events || '').split(' ');
    try {
        eventList.forEach(function (ev) {
            // @ts-ignore
            element.addEventListener(ev, handler);
        });
        return function () {
            eventList.forEach(function (ev) {
                // @ts-ignore
                element.removeEventListener(ev, handler);
            });
        };
    }
    catch (e) {
        reportError(e);
    }
    return NoOp;
}
